export default "__VITE_ASSET__Cc__JceI__"